module.exports = __webpack_public_path__ + "static/media/pg_table_bg.ef74165d.jpg";